import { CreateFalseArray } from "../../Functions/functions";

export default function Modal_true(props) {
  // const [modalIsOpen, setIsOpen] = useState(false);

  function closeModal() {
    props.setIsOpen(false);
    // let darkenedButton = document.getElementsByClassName("darken_btn")[0];

    // darkenedButton.classList.remove("darken_btn");
  }

  function handleOnChange() {
    // props.Allcheck[props.index] = !props.check;
    //
    // props.setChecked(props.Allcheck);
  }

  let backgroundImageClass = "background_image";
  let faceClass = "face_sketch";
  let mainMessageClass = "main_message";
  let secMessageClass = "secondary_message";
  let keepPlayClass = "keep_playing";

  //    const questionImageCheck = document.querySelector("question-image");

  // ReactDOM.findDOMNode(component)

  const gameLang = document.documentElement.lang || process.env.REACT_APP_LANG_TYPE;
  var continueText = "";
  var ButtonText = "";
  var mainMessageText1 = "";
  var mainMessageText2 = "";

  if (gameLang === "en") {
    mainMessageText1 = "Well done!";
    mainMessageText2 = "That is the correct answer!";
    continueText = "Continue";
    ButtonText = "button-text continue-english";
  } else {
    mainMessageText1 = "Μπράβο!";
    mainMessageText2 = "Αυτή είναι η σωστή απάντηση!";
    continueText = "Συνέχισε";
    ButtonText = "button-text";
  }

  return (
    <div className="modal_container true">
      <div className={faceClass}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="128"
          height="128"
          viewBox="0 0 128 128"
        >
          <g
            id="Group_259"
            data-name="Group 259"
            transform="translate(-6697.25 -538.768)"
          >
            <circle
              id="Ellipse_87"
              data-name="Ellipse 87"
              cx="64"
              cy="64"
              r="64"
              transform="translate(6697.25 538.768)"
              fill="#e8e8e6"
            />
            <g id="Group_258" data-name="Group 258">
              <path
                id="Path_886"
                data-name="Path 886"
                d="M6761.25,565.068a36.9,36.9,0,1,1-36.9,36.9,36.95,36.95,0,0,1,36.9-36.9m0-3.6a40.5,40.5,0,1,0,40.5,40.5,40.446,40.446,0,0,0-40.5-40.5Zm-17.1,24.75c-2.52,0-4.5,2.61-4.5,5.85s1.98,5.85,4.5,5.85,4.5-2.61,4.5-5.85S6746.67,586.218,6744.15,586.218Zm34.2,0c-2.52,0-4.5,2.61-4.5,5.85s1.98,5.85,4.5,5.85,4.5-2.61,4.5-5.85S6780.87,586.218,6778.35,586.218Zm7.11,25.38a1.793,1.793,0,1,0-3.42-1.08,21.957,21.957,0,0,1-41.58-.09,1.793,1.793,0,1,0-3.42,1.08,25.536,25.536,0,0,0,48.42.09Z"
                fill="#222"
              />
            </g>
          </g>
        </svg>
      </div>
      <div className={mainMessageClass}>
        {mainMessageText1} <br /> {mainMessageText2}
      </div>
      {/* <div className={secMessageClass}> */}
      {/* {props.answer} */}
      {/* Οι ναοί κτίζονταν σε κεντρικά σημεία των πόλεων, ενώ σπανιότερα κτίζονταν κοιμητηριακοί ναοί έξω από τα τείχη. */}
      {/* </div> */}
      <button
        className={keepPlayClass}
        onClick={() => {
          //handleOnChange();
          props.scount(props.mycount + 1);
          closeModal();
        }}
      >
        <span className={ButtonText}>{continueText}</span>
      </button>
    </div>
  );
}
